/* import __COLOCATED_TEMPLATE__ from './capture-composer.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();